import React from 'react';
import './HelpSection.css';

const HelpSection = () => {
    const items = [
        { title: "Healthcare Providers", description: "Support your chronic patients’ gait and walking health needs.", linkText: "Find out more", image: "/Images/image 5.png" },
        { title: "Runners", description: "Personalised AI running coach for postural corrections.", linkText: "Find out more", image: "/Images/image 1.png" },
        { title: "Visually Impaired Individuals", description: "Haptic direction guides for short trips.", linkText: "Contact us", image: "/Images/image 2.png" },
        { title: "Adults with Osteoporosis", description: "Lessen pain through walking posture enhancements.", linkText: "Contact us", image: "/Images/image 3.png" },
        { title: "Kids", description: "Lay the foundation for children’s foot health!", linkText: "Contact us", image: "/Images/image 4.png" }
    ];

    return (
        <div className="help-section">
            <h2>How can we help?</h2>
            <div className="help-items">
                {items.map((item, index) => (
                    <div key={index} className="help-item">
                        <img src={item.image} alt={item.title} className="help-image" />
                        <div className="help-content">
                            <h3>For<br /><span>{item.title}</span></h3>
                            <p>{item.description}</p>
                            <a href="mailto:info@digitoe.ai" className="help-link">{item.linkText} &gt;</a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HelpSection;
